export default "__VITE_ASSET__DdMVt8lD__"